import $ from 'jquery';

class ApplicationEditor {
	
	constructor() {
		if ($("#application-editor").length > 0) {
			this.init();
		}
	}

	init() {
		
		Vue.component('panel',  () => import('../components/Panel.vue'));
		Vue.component('application-editor',  () => import('../components/ApplicationEditor.vue'));

	}


}

export default ApplicationEditor;
